import { render, staticRenderFns } from "./RedesSociales.vue?vue&type=template&id=4b91bf33&scoped=true&"
import script from "./RedesSociales.vue?vue&type=script&lang=js&"
export * from "./RedesSociales.vue?vue&type=script&lang=js&"
import style0 from "./RedesSociales.vue?vue&type=style&index=0&id=4b91bf33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b91bf33",
  null
  
)

export default component.exports